import React, { useState } from 'react';
//import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Modal } from 'react-bootstrap';
import Template1 from './Template1';
import Template2 from './Template2';
import Template3 from './Template3';
import Template4 from './Template4';

import template1Thumbnail from './templete-images/template1.jpg';
import template2Thumbnail from './templete-images/template2.jpg';
import template3Thumbnail from './templete-images/template3.jpg';
import template4Thumbnail from './templete-images/template4.jpg';
import sampleImage from './templete-images/sample-image.jpg';
import './styles/Website-Templates.css';

const WebsiteTemplates = () => {
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const dummyEvent = {
        event_title: "Sample Wedding",
        event_date: new Date(),
        description: "Sample wedding description",
        wallpaper: [{ md_photo: sampleImage }]
    };

    const templates = [
        { id: 1, name: "Template 1", component: <Template1 event={dummyEvent} />, image: template1Thumbnail },
        { id: 2, name: "Template 2", component: <Template2 event={dummyEvent} />, image: template2Thumbnail },
        { id: 3, name: "Template 3", component: <Template3 event={dummyEvent} />, image: template3Thumbnail },
        { id: 4, name: "Template 4", component: <Template4 event={dummyEvent} />, image: template4Thumbnail }
    ];

    return (
        <Container className="templates-container">
            <h1 className="stylish-heading text-center" style={{ color: '#4169e1' }}>Website Templates</h1>


            <Row className="templates-grid">
                {templates.map((template) => (
                    <Col md={4} xs={12} key={template.id} className="template-column">
                        <Card className="template-card">
                            <Card.Img variant="top" src={template.image} alt={`${template.name} preview`} className="template-image" />
                            <Card.Body>
                                <Card.Title className="template-name">{template.name}</Card.Title>
                                <Button
                                    className="preview-btn"
                                    onClick={() => setSelectedTemplate(template.name)}
                                >
                                    Preview Template
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>

            <Modal
                show={selectedTemplate !== null}
                onHide={() => setSelectedTemplate(null)}
                size="md"
                centered
            >
                <Modal.Header closeButton className="border-0">
                    <Modal.Title className="w-100 text-center fw-bold mt-3" style={{ color: '#4169e1', fontSize: '1.8rem', letterSpacing: '-0.5px' }}>
                        Coming Soon!
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center px-4 pb-4">
                    <p style={{ fontSize: '1.05rem', color: '#475569', lineHeight: '1.6' }}>
                        We are currently designing and building gorgeous, premium website templates for your special event. 
                        This feature will be available very soon!
                    </p>
                    <div style={{ fontSize: '3rem', margin: '20px 0' }}>🎨✨🚀</div>
                    <Button 
                        onClick={() => setSelectedTemplate(null)}
                        style={{
                            backgroundColor: '#4169e1',
                            border: 'none',
                            borderRadius: '25px',
                            padding: '10px 30px',
                            fontWeight: '600',
                            marginTop: '15px',
                            boxShadow: '0 4px 12px rgba(65, 105, 225, 0.2)'
                        }}
                    >
                        Ok, I'll Wait
                    </Button>
                </Modal.Body>
            </Modal>
        </Container>
    );
};

export default WebsiteTemplates;